import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../../hooks/useSafariPaymentReset";
import CustomInput from "../../../custom/CustomInput";
import CustomSelect from "../../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../loader/CircularIndeterminate";

const OnetoOne = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { courseByEvents } = useSelector((state) => state.courseByEvents);

  useEffect(() => {
    dispatch(actions.courseByEventsGetData({ id: "28" }));
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      date: values.date,
      preferred_day: values.preferred_day,
      preferred_time: values.preferred_time,
      your_exam: values.your_exam,
      totalfees: values.totalfees,
      course_id: values.course_id,
      is_online_payment: values.is_online_payment,
      is_enquiry: values.is_enquiry,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  date: "",
                  preferred_day: "",
                  preferred_time: "",
                  your_exam: "1 to 1",
                  course_id: "",
                  is_enquiry: "0",
                  is_online_payment: "1",
                  totalfees: "1500",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                })}
              >
                {(formProps) => (
                  <Form className="mt-3">
                    {console.log("formProps music", formProps.values)}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="clientname" className="label">
                          Your Full Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientname"
                            id="clientname"
                            placeholder="Enter Your Name"
                            className={
                              "form-control" +
                              (formProps.errors.clientname &&
                              formProps.touched.clientname
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientname"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="clientemail" className="label">
                          Your Email:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientemail"
                            id="clientemail"
                            placeholder="Enter Your Email"
                            className={
                              "form-control" +
                              (formProps.errors.clientemail &&
                              formProps.touched.clientemail
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientemail"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="clientphone" className="label">
                          Your Mobile:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientphone"
                            id="clientphone"
                            placeholder="Enter Your Mobile"
                            className={
                              "form-control" +
                              (formProps.errors.clientphone &&
                              formProps.touched.clientphone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientphone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="course_id" className="label">
                          Select Your Course:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="course_id"
                            id="course_id"
                            className={
                              "form-control" +
                              (formProps.errors.course_id &&
                              formProps.touched.course_id
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value={""}>Select Your Course</option>
                            {courseByEvents?.map((course) => {
                              return (
                                <option value={course.id} key={course.id}>
                                  {course.name}
                                </option>
                              );
                            })}
                          </Field>
                          <ErrorMessage
                            name="course_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="date" className="label">
                          Select Your Day:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="date"
                            name="date"
                            id="date"
                            className={
                              "form-control" +
                              (formProps.errors.date && formProps.touched.date
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="date"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="preferred_day" className="label">
                          Select Your Preferred Day:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="preferred_day"
                            id="preferred_day"
                            className={
                              "form-control" +
                              (formProps.errors.preferred_day &&
                              formProps.touched.preferred_day
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option>Select Your Preferred Day</option>
                            <option value={"Sunday"}>Sunday</option>
                            <option value={"Monday"}>Monday</option>
                            <option value={"Tuesday"}>Tuesday</option>
                            <option value={"Wednesday"}>Wednesday</option>
                            <option value={"Thursday"}>Thursday</option>
                            <option value={"Friday"}>Friday</option>
                            <option value={"Saturday"}>Saturday</option>
                          </Field>
                          <ErrorMessage
                            name="preferred_day"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="preferred_time" className="label">
                          Select Your Preferred Time:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="time"
                            name="preferred_time"
                            id="preferred_time"
                            className={
                              "form-control" +
                              (formProps.errors.preferred_time &&
                              formProps.touched.preferred_time
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="preferred_time"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    {/* preferred_time */}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="totalfees" className="label">
                          Your Amount:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            disabled
                            name="totalfees"
                            id="totalfees"
                            placeholder="Enter Your Amount"
                            className={
                              "form-control" +
                              (formProps.errors.totalfees &&
                              formProps.touched.totalfees
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="totalfees"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <div className="mt-3 mb-3 row mt-5">
                      <div className="col-12">
                        <Button
                          type="submit"
                          className="register-btn"
                          size="md"
                          block
                        >
                          {isPostLoading ? <CircularLoading /> : "PAY NOW"}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default OnetoOne;
